import type {
    ComposableOptionsBase,
    ProductMarket,
    ProductCategory,
    ProductCatalogMenuSelection,
    ProductCategoryItem
} from '~/types';

const ProdCatFilterForm = () => useState<Record<string, Nilish<string>>>('keyProdCatFilterForm', () => ({}));

export interface UseProductCatalogOptions extends ComposableOptionsBase {}
export function useProductCatalog(options: Partial<UseProductCatalogOptions> = {}) {
    const filterForm = ProdCatFilterForm();

    function findMenuSelectionItem(
        marketObj: ProductMarket[],
        path: string
    ): Nilish<ProductCatalogMenuSelection> {
        let foundItem: any = null;

        function findItem(
            items: Pick<ProductMarket, 'categories'>[] | Pick<ProductCategory, 'products'>[],
            subProp?: 'categories' | 'products'
        ): Undefinable<ProductCatalogMenuSelection> {
            if (foundItem) return;
            
            for (let idx = 0; idx < items.length; idx++) {
                const item = items[idx] as ProductMarket | ProductCategory;

                if (item.path === path) {
                    foundItem = item;
                    break;
                }
            
                subProp = getSubProp(item, subProp);
                
                if (subProp && subProp in item) {
                    // @ts-ignore
                    findItem(item[subProp]);
                }
            }
        }

        findItem(marketObj, 'categories');
        return foundItem;
    }

    function filterMenu(
        marketsObj: ProductMarket[],
        term: string
    ): ProductMarket[] {
        return marketsObj.reduce((acc1: ProductMarket[], item: ProductMarket) => {
            // If Group name contains term, just return the whole group
            if (item.name.toLowerCase().includes(term.toLowerCase())) {
                acc1.push(item);
                return acc1;
            }

            const subItems = item.categories?.reduce((acc2: ProductCategory[], subItem: ProductCategory) => {
                const subSubItems = subItem.products?.filter((subSubItem: ProductCategoryItem) => {
                    if (subSubItem.name.toLowerCase().includes(term.toLowerCase())) {
                        return subSubItem;
                    }
                });

                if (subSubItems?.length) {
                    acc2.push({
                        ...subItem,
                        products: subSubItems
                    });
                }

                return acc2;
            }, []);

            if (subItems?.length) {
                acc1.push({
                    ...item,
                    categories: subItems
                });
            }

            return acc1;
        }, []);
    }

    // Helpers

    function getSubProp(
        item: ProductMarket | ProductCategory,
        defaultProp?: Undefinable<'categories' | 'products'>
    ): Undefinable<'categories' | 'products'> {
        switch (true) {
            case 'categories' in item: return 'categories';
            case 'products' in item: return 'products';
            default: return defaultProp
        }
    }
    
    return {
        filterForm,
        findMenuSelectionItem,
        filterMenu
    };
}
